import trackerAPI from '@/api/tracker'
import { log } from '@/utils'

async function SPTracker (name, desc, params) {
  log.debug(`trackerAPI[${name}]`, params)
  if (!name || !trackerAPI[name]) return console.error(`trackerAPI${name}不存在`)
  const res = await trackerAPI[name](params)
  return res
}

export default SPTracker
